import { Cell } from "recharts";

const BaseCell = Cell

export default BaseCell;